const QUOTES = [
  {
    quote: "Mi hija va sola al cole y yo trabajo tranquila. Cuando llega, me llega el aviso. Ni una llamada de nervios.",
    name: "Lucía M.",
    role: "Mamá de Emma, 8 años",
  },
  {
    quote: "Lo mejor es que no es un móvil. Nada de pantallas ni apps. Solo llamarnos y saber que está bien.",
    name: "Daniel R.",
    role: "Papá de Hugo, 7 años",
  },
  {
    quote: "El botón SOS nos dio la paz que buscábamos sin agobiar a nuestro hijo. Él lo ve como su reloj de superhéroe.",
    name: "Sara P.",
    role: "Mamá de Leo, 9 años",
  },
];

export default function Testimonials() {
  return (
    <section className="bg-[#F3F2F2] border-b-2 border-[#12263A]">
      <div className="max-w-6xl mx-auto px-5 py-16 md:py-24">
        <span className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#2E9EF0]">Familias Kiddio</span>
        <h2 className="mt-3 text-[28px] md:text-[40px] font-black text-[#12263A] leading-tight max-w-2xl">
          Padres tranquilos. Niños libres.
        </h2>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {QUOTES.map((q) => (
            <figure
              key={q.name}
              data-testid="testimonial-card"
              className="bg-white border-2 border-[#12263A] p-7 flex flex-col gap-5"
              style={{ borderRadius: "28px" }}
            >
              <blockquote className="text-[17px] leading-[1.6] text-[#12263A]">“{q.quote}”</blockquote>
              <figcaption className="flex items-center gap-3 mt-auto">
                <span
                  className="w-11 h-11 flex items-center justify-center bg-[#2E9EF0] border-2 border-[#12263A] font-black text-[#12263A]"
                  style={{ borderRadius: "31%" }}
                >
                  {q.name.charAt(0)}
                </span>
                <span>
                  <span className="block font-black text-[#12263A] text-[15px]">{q.name}</span>
                  <span className="block text-[13px] text-[#6E7B8B]">{q.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
